import React, { Component } from "react";
import { connect } from "react-redux";
import Loader from "react-loader";
import { getFormValues } from "redux-form";
import { Container } from "reactstrap";
import Layout from "../components/Layout";
import PageNav from "../components/PageNav";
import PageForm from "../modules/PageForm";
import { fetchPageDetail } from "../modules/PageDetail/actions";
import { isLoaded, getError } from "../modules/PageDetail/selectors";
import { PAGE_FORM_NAME } from "../modules/PageForm/constants";

class EditBasicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchPageDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, pageInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...pageInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit stránku</h1>
            </PageNav>
            <PageForm config={this.getConfig()} initialValues={initialValues} />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pageInitialValues: getFormValues(PAGE_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state),
  };
};

export default connect(mapStateToProps, { fetchPageDetail })(EditBasicPage);



// WEBPACK FOOTER //
// ./src/pages/EditBasicPage.js